<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <div class="mingTitlr">入库基本信息</div>
        <el-form size="small" ref="searchForm" :model="searchForm" label-width="110px">
            <div class="flex_l_t flex_w">
                <el-form-item label="入库原因：" prop="inWarehouseCause" class="itemFormWidth">
                    <div>{{ $dictUtils.getDictLabel("in_warehouse_cause", searchForm.inWarehouseCause, '') }}</div>
                </el-form-item>
                <el-form-item label="预入库时间：" prop="inWarehouseTime" class="itemFormWidth">
                    <div>{{ searchForm.inWarehouseTime }}</div>
                </el-form-item>
                <el-form-item label="申请人：" prop="applicant" class="itemFormWidth">
                    <div>{{ searchForm.applicant }}</div>
                </el-form-item>
                <el-form-item label="申请部门：" prop="departmentNameByUserId" class="itemFormWidth">
                    <div>{{ searchForm.departmentNameByUserId }}</div>
                </el-form-item>
                <el-form-item label="申请时间：" prop="applicantTime" class="itemFormWidth">
                    <div>{{ searchForm.applicantTime }}</div>
                </el-form-item>
            </div>
            <el-form-item label="入库描述：" prop="inWarehouseDescribe">
                <div>{{ searchForm.inWarehouseDescribe }}</div>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <div>{{ searchForm.remark }}</div>
            </el-form-item>
            <div class="flex_l_t flex_w">
                <el-form-item label="审批状态：" prop="status" class="itemFormWidth">
                    <div>{{ $dictUtils.getDictLabel("collection_status", searchForm.status, '') }}</div>
                </el-form-item>
                <el-form-item label="审批人：" prop="handleByName" class="itemFormWidth">
                    <div>{{ searchForm.handleByName }}</div>
                </el-form-item>
                <el-form-item label="审批时间：" prop="handleTime" class="itemFormWidth">
                    <div>{{ searchForm.handleTime }}</div>
                </el-form-item>
            </div>
            <el-form-item label="审批建议：" prop="reviewComments">
                <div>{{ searchForm.reviewComments }}</div>
            </el-form-item>
            <div class="flex_l_t flex_w">
                <el-form-item label="入库编号：" prop="itemId" class="itemFormWidth">
                    <div>{{ searchForm.itemId }}</div>
                </el-form-item>
                <el-form-item label="库房名称：" prop="warehouseName" class="itemFormWidth">
                    <div>{{ searchForm.warehouseName }}</div>
                </el-form-item>
                <el-form-item label="所在位置：" prop="shelfName" class="itemFormWidth">
                    <div>{{ searchForm.shelfName }}</div>
                </el-form-item>
                <el-form-item label="入库点交人：" prop="delivererName" class="itemFormWidth">
                    <div>{{ searchForm.delivererName }}</div>
                </el-form-item>
                <el-form-item label="入库点收人：" prop="receiverName" class="itemFormWidth">
                    <div>{{ searchForm.receiverName }}</div>
                </el-form-item>
                <el-form-item label="交接时间：" prop="receiverTime" class="itemFormWidth">
                    <div>{{ searchForm.receiverTime }}</div>
                </el-form-item>
            </div>
            <el-form-item label="附件：" prop="metadataAttachments">
                <div class="metadataAttachmentsList">
                    <el-card class="elCard" v-for="item in searchForm.metadataAttachments" :key="item.id">
                        <div class="flex_b_c">
                            <div class="flex_l_c flex_1">
                                <i class="el-icon-tickets icong"></i>
                                <el-tooltip class="item" effect="dark" :content="item.fileName"
                                            placement="top-start">
                                    <div class="content omit">{{ item.fileName }}</div>
                                </el-tooltip>
                            </div>
                            <div></div>
                        </div>
                    </el-card>
                </div>
            </el-form-item>
            <div class="mingTitlr">出库藏品</div>
            <div class="flex_l_t flex_w">
                <el-form-item label="子产品：" prop="delivererBy" class="itemFormWidth">
                    <div>{{ searchForm.delivererBy }}</div>
                </el-form-item>
                <el-form-item label="出库接收人：" prop="receiverBy" class="itemFormWidth">
                    <div>{{ searchForm.receiverBy }}</div>
                </el-form-item>
                <el-form-item label="交接时间：" prop="receiverTime" class="itemFormWidth">
                    <div>{{ searchForm.receiverTime }}</div>
                </el-form-item>
            </div>
        </el-form>
        <add-edit-form-item ref="addEditFormItem" refName="addEditFormItem" :list="fieldList" :form="form"
                            :allForm="form" :method="method" :configId="configId" :basicDataId="basicDataId"
                            @refreshData="refreshData" :attachmentList="attachmentList"></add-edit-form-item>
        <!--子表单、子模板-->
        <el-collapse v-model="activeNames" v-if="formList.length">
            <el-collapse-item :title="item.basicRename" :name="index" v-for="(item, index) in formList"
                              :key="index">
                <!--子表单-->
                <div v-if="item.basicAssemblyId == '19'">
                    <div class="p_l1">
                        <el-button type="primary" size="small" icon="el-icon-plus" v-if="method != 'view'"
                                   @click="addEidtSubform(null, 'add', item)">新增
                        </el-button>
                        <el-button size="small" @click="importData(item)" v-if="method != 'view'">
                            <i class="icon-piliangdaoru iconfont buIcon"/>批量导入
                        </el-button>
                        <el-button size="small" @click="exportData(item)" v-if="method == 'edit'">
                            <i class="icon-piliangdaochu iconfont buIcon"/>批量导出
                        </el-button>
                        <el-button size="small" @click="downloadSubform(item)" v-if="method == 'edit'">
                            <i class="icon-piliangdaochu iconfont buIcon"/>批量下载
                        </el-button>
                        <el-button type="danger" size="small" icon="el-icon-delete" v-if="method != 'view'"
                                   @click="delSubform(item)">批量删除
                        </el-button>
                    </div>
                    <el-table :data="form[item.basicCode]" :ref="item.basicCode"
                              @selection-change="selectionChangeHandle($event, item)" size="small" max-height="300"
                              class="table m_t1" border>
                        <el-table-column fixed type="selection"></el-table-column>
                        <el-table-column v-for="(v, i) in item.children" :key="i" :prop="v.basicCode"
                                         :label="v.basicRename" show-overflow-tooltip
                                         v-if="v.basicAssemblyId != 3 && v.basicAssemblyId != 13 && v.basicAssemblyId != 14 && v.basicAssemblyId != 15 && v.basicAssemblyId != 16 && v.basicAssemblyId != 17 && v.basicAssemblyId != 18">
                            <template slot-scope="scope">
                                <span>{{ listDataFormat(v, scope.row[v.basicCode]) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="160">
                            <template slot-scope="scope">
                                <el-button type="text" size="small"
                                           @click="addEidtSubform(scope.row, 'view', item)">详情
                                </el-button>
                                <el-button type="text" size="small" v-if="method != 'view'"
                                           @click="addEidtSubform(scope.row, 'edit', item)">修改
                                </el-button>
                                <el-button type="text" size="small" v-if="method == 'edit'"
                                           @click="downloadSubform(item, scope.row)">下载
                                </el-button>
                                <el-button type="text" size="small" v-if="method != 'view'"
                                           @click="delSubform(item, scope.$index)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!--子模板-->
                <div v-if="item.basicAssemblyId == '20'">
                    <add-edit-form-item :ref="`ref${item.basicCode}`" :refName="item.basicCode" :list="item.children"
                                        :form="form[item.basicCode]" :allForm="form"
                                        :method="method" :configId="configId"
                                        :basicDataId="basicDataId"></add-edit-form-item>
                </div>
            </el-collapse-item>
        </el-collapse>
        <add-eidt-subform ref="addEidtSubform"></add-eidt-subform>
        <ImportData ref="importData" @refreshData="getSubform"></ImportData>
        <ExportData ref="exportData"></ExportData>
        <set-toexamine ref="setToexamine" @refresh="refreshData(1,1)"></set-toexamine>
    </el-dialog>
</template>

<script>
import AddEditFormItem from "@/views/modules/dyygCollect/library/AddEditFormItem.vue";
import ImportData from "@/components/importData/importData.vue";
import AddEidtSubform from "@/views/modules/dyygCollect/library/AddEidtSubform.vue";
import ExportData from "@/components/exportData/exportData.vue";
import SetToexamine from "@/components/toExamine/setToexamine.vue";

export default {
    name: "collDetail",
    components: {SetToexamine, ExportData, AddEidtSubform, ImportData, AddEditFormItem},
    data() {
        return {
            title: '入库藏品详情',
            visible: false,
            searchForm: {},

            method: 'view',
            configId: '',
            fieldList: [],
            form: {},
            basicDataId: '',
            attachmentList: [],
            associatedItem: [],
            formList: [],
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.getDetail(row)
        },

        getDetail(row) {
            this.$axios(this.api.collection.getInWarehouseCollectionInfo + row.itemId).then(data => {
                if (data && data.status) {
                    this.searchForm = data.data
                    this.basicDataId = data.data.metadataData.basicDataId
                    this.getFields(data.data.metadataDataSetting)
                    this.getInfo(data.data.metadataData)
                }
            })
        },

        getFields(data) {
            this.fieldList = data.children
            this.fieldList.map(item => {
                if (item.basicAssemblyId == '19' || item.basicAssemblyId == '20') {
                    this.formList.push(item)
                }
            })
            this.recursion(this.fieldList, this.form)
        },

        // 递归
        recursion(list, form) {
            list.map(item => {
                if (!item.basicCode) {
                    return
                }
                if (item.basicAssemblyId == 16) {
                    this.$set(item, 'associatedBasicDataId', 0)
                    if (item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.associationBasicDataId) {
                        this.associatedItem.push(item)
                    }
                }
                if (item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 16 || item.basicAssemblyId == 17 || item.basicAssemblyId == 19) {
                    this.$set(form, item.basicCode, [])
                } else if (item.basicAssemblyId == 18 || item.basicAssemblyId == 20) {
                    this.$set(form, item.basicCode, {})
                } else {
                    if (item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleDefaultValue) {
                        this.$set(form, item.basicCode, item.metadataBasicDataRuleVo.ruleDefaultValue)
                    } else {
                        this.$set(form, item.basicCode, null)
                    }
                }
                if (item.children.length && (item.basicAssemblyId == 18 || item.basicAssemblyId == 20)) {
                    this.recursion(item.children, this.form[item.basicCode])
                }
            })
        },

        // 获取详情信息
        getInfo(data) {
            this.form = this.recover(this.form, data.jsonData);
            this.attachmentList = data.data.metadataAttachments;
            if (!this.associatedItem.length) {
                this.loading = false
                return
            }
            this.associatedItem.map(item => {
                if (this.form[item.basicCode].length) {
                    this.getAssociated(item.metadataBasicDataRuleVo.associationBasicDataId, this.form[item.basicCode], item)
                } else {
                    this.loading = false
                }
            })
        },

        // 获取关联数据
        getAssociated(configId, ids, item) {
            this.$axios(this.api.metadata.groupByTemplate + "?configId=" + configId, ids, 'post').then(data => {
                if (data.status) {
                    this.$set(item, 'basicDataIdList', data.data.basicDataIdList)
                }
                this.loading = false
            })
        },

        refreshData() {
            this.visible = false
            this.$emit('refreshData')
        },

        // 获取子表单数据
        getSubform(data) {
            if (data && data.length) {
                data.map(item => {
                    this.form[this.importBasicCode].push(item.jsonData)
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.mingTitlr {
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 15px;
}

.itemFormWidth {
  width: 33%;
}

.metadataAttachmentsList {
  width: 50%;
  height: 250px;
  overflow-y: auto;
}

.elCard {
  &::v-deep .el-card__body {
    padding: 10px !important;
  }

  margin-bottom: 15px;

  .icong {
    font-size: 18px;
    margin-right: 10px;
  }

  .content {
    width: 80%;
  }

  .deeldClose {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>